import { PolicyDocumentType } from '@acorn-portal/shared/src/services/api';
import { Company, Product } from '@acorn-portal/shared/src/services/interface/Shared';
import {
	ACORN_NCB_STATEMENT,
	ACORN_PRIVACY_POLICY,
	ACORN_TERMS_OF_BUSINESS,
	ACORN_XS_REIMBURSEMENT_BOOKLET,
	ACORN_XS_REIMBURSEMENT_IPID,
	ACORN_CV_IPID,
	ACORN_PC_IPID,
	ACORN_PROTECT_IPID,
	ACORN_PROTECT_POLICY_BOOKLET,
	ACORN_SHORT_TERM_IPID,
	ACORN_SHORT_TERM_TAXI_IPID,
	ACORN_TAXI_ANNUAL_IPID,
	addonDocumentEnums,
	CARROT_IPID,
	CARROT_NCB_STATEMENT,
	CARROT_POLICY_BOOKLET,
	CARROT_PRIVACY_POLICY,
	CARROT_TERMS_OF_BUSINESS,
	CARROT_XS_REIMBURSEMENT_BOOKLET,
	CARROT_XS_REIMBURSEMENT_IPID,
	CV_POLICY_BOOKLET,
	documentTypes,
	genericDocumentEnums,
	MOTORCADE_NCB_STATEMENT,
	MOTORCADE_XS_REIMBURSEMENT_BOOKLET,
	MOTORCADE_XS_REIMBURSEMENT_IPID,
	MOTORCADE_IPID,
	MOTORCADE_POLICY_BOOKLET,
	MOTORCADE_TERMS_OF_BUSINESS,
	PRIVATE_CAR_POLICY_BOOKLET,
	SHORT_TERM_PRIVATE_CAR_POLICY_BOOKLET,
	TAXI_ANNUAL_POLICY_BOOKLET,
	TAXI_SHORT_TERM_POLICY_BOOKLET,
	FLAG_EXCESS_IPID_BOOKLET,
	FLAG_EXCESS_IPID,
	FLAG_POLICY_BOOKLET,
	FLAG_NCB_STATEMENT,
	FLAG_IPID,
	FLAG_PRIVACY_POLICY,
	FLAG_TERMS_OF_BUSINESS,
	MYPOLICY_POLICY_BOOKLET,
	MYPOLICY_XS_REIMBURSEMENT_IPID,
	MYPOLICY_XS_REIMBURSEMENT_BOOKLET,
	MYPOLICY_NCB_STATEMENT,
	MYPOLICY_IPID,
	MYPOLICY_PRIVACY_POLICY,
	MYPOLICY_TERMS_OF_BUSINESS,
	STREET_COVER_PRIVACY_POLICY,
	STREET_COVER_TERMS_OF_BUSINESS,
	ACORN_SUBSCRIPTION_IPID,
	ACORN_SUBSCRIPTION_POLICY_BOOKLET,
	STREET_COVER_ANNUAL_POLICY_BOOKLET,
	STREET_COVER_30_DAY_POLICY_BOOKLET,
	STREET_COVER_30_DAY_IPID,
	STREET_COVER_ANNUAL_IPID,
	STREET_COVER_NCB_PROTECTION,
} from '@acorn-portal/shared/src/utils/constants';

const documentMappings: Record<Company, any> = {
	ACORN: {
		[PolicyDocumentType.POLICY_WORDING]: {
			[Product.PRIVATE_CAR]: PRIVATE_CAR_POLICY_BOOKLET,
			[Product.COMMERCIAL_VEHICLE]: CV_POLICY_BOOKLET,
			[Product.TELEMATICS]: ACORN_PROTECT_POLICY_BOOKLET,
			[Product.SHORT_TERM]: SHORT_TERM_PRIVATE_CAR_POLICY_BOOKLET,
			[Product.SUBSCRIPTION]: ACORN_SUBSCRIPTION_POLICY_BOOKLET,
			[Product.TAXI]: {
				shortTerm: TAXI_SHORT_TERM_POLICY_BOOKLET,
				longTerm: TAXI_ANNUAL_POLICY_BOOKLET,
			},
		},
		[addonDocumentEnums.XS_REIMBURSEMENT]: ACORN_XS_REIMBURSEMENT_IPID,
		[addonDocumentEnums.XS_REIMBURSEMENT_BOOKLET]: ACORN_XS_REIMBURSEMENT_BOOKLET,
		[addonDocumentEnums.NCB_PROTECTION]: ACORN_NCB_STATEMENT,
		[PolicyDocumentType.IPID]: {
			[Product.SHORT_TERM]: ACORN_SHORT_TERM_IPID,
			[Product.PRIVATE_CAR]: ACORN_PC_IPID,
			[Product.SUBSCRIPTION]: ACORN_SUBSCRIPTION_IPID,
			[Product.COMMERCIAL_VEHICLE]: ACORN_CV_IPID,
			[Product.TELEMATICS]: ACORN_PROTECT_IPID,
			[Product.TAXI]: {
				shortTerm: ACORN_SHORT_TERM_TAXI_IPID,
				longTerm: ACORN_TAXI_ANNUAL_IPID,
			},
		},
		[genericDocumentEnums.PRIVACY_POLICY]: ACORN_PRIVACY_POLICY,
		[genericDocumentEnums.TERMS_OF_BUSINESS]: ACORN_TERMS_OF_BUSINESS,
	},
	MOTORCADE: {
		[PolicyDocumentType.POLICY_WORDING]: {
			[Product.PRIVATE_CAR]: MOTORCADE_POLICY_BOOKLET,
		},
		[addonDocumentEnums.XS_REIMBURSEMENT]: MOTORCADE_XS_REIMBURSEMENT_IPID,
		[addonDocumentEnums.XS_REIMBURSEMENT_BOOKLET]: MOTORCADE_XS_REIMBURSEMENT_BOOKLET,
		[addonDocumentEnums.NCB_PROTECTION]: MOTORCADE_NCB_STATEMENT,
		[PolicyDocumentType.IPID]: { [Product.PRIVATE_CAR]: MOTORCADE_IPID },
		[genericDocumentEnums.PRIVACY_POLICY]: ACORN_PRIVACY_POLICY,
		[genericDocumentEnums.TERMS_OF_BUSINESS]: MOTORCADE_TERMS_OF_BUSINESS,
	},
	CARROT: {
		[PolicyDocumentType.POLICY_WORDING]: {
			[Product.CARROT]: CARROT_POLICY_BOOKLET,
		},
		[addonDocumentEnums.XS_REIMBURSEMENT]: CARROT_XS_REIMBURSEMENT_IPID,
		[addonDocumentEnums.XS_REIMBURSEMENT_BOOKLET]: CARROT_XS_REIMBURSEMENT_BOOKLET,
		[addonDocumentEnums.NCB_PROTECTION]: CARROT_NCB_STATEMENT,
		[PolicyDocumentType.IPID]: { [Product.CARROT]: CARROT_IPID },
		[genericDocumentEnums.PRIVACY_POLICY]: CARROT_PRIVACY_POLICY,
		[genericDocumentEnums.TERMS_OF_BUSINESS]: CARROT_TERMS_OF_BUSINESS,
	},
	FLAG: {
		[PolicyDocumentType.POLICY_WORDING]: {
			[Product.TAXI]: FLAG_POLICY_BOOKLET,
		},
		[addonDocumentEnums.XS_REIMBURSEMENT]: FLAG_EXCESS_IPID,
		[addonDocumentEnums.XS_REIMBURSEMENT_BOOKLET]: FLAG_EXCESS_IPID_BOOKLET,
		[addonDocumentEnums.NCB_PROTECTION]: FLAG_NCB_STATEMENT,
		[PolicyDocumentType.IPID]: { [Product.TAXI]: FLAG_IPID },
		[genericDocumentEnums.PRIVACY_POLICY]: FLAG_PRIVACY_POLICY,
		[genericDocumentEnums.TERMS_OF_BUSINESS]: FLAG_TERMS_OF_BUSINESS,
	},
	MYPOLICY: {
		[PolicyDocumentType.POLICY_WORDING]: {
			[Product.TELEMATICS]: MYPOLICY_POLICY_BOOKLET,
		},
		[addonDocumentEnums.XS_REIMBURSEMENT]: MYPOLICY_XS_REIMBURSEMENT_IPID,
		[addonDocumentEnums.XS_REIMBURSEMENT_BOOKLET]: MYPOLICY_XS_REIMBURSEMENT_BOOKLET,
		[addonDocumentEnums.NCB_PROTECTION]: MYPOLICY_NCB_STATEMENT,
		[PolicyDocumentType.IPID]: { [Product.TELEMATICS]: MYPOLICY_IPID },
		[genericDocumentEnums.PRIVACY_POLICY]: MYPOLICY_PRIVACY_POLICY,
		[genericDocumentEnums.TERMS_OF_BUSINESS]: MYPOLICY_TERMS_OF_BUSINESS,
	},
	STREETCOVER: {
		[PolicyDocumentType.POLICY_WORDING]: {
			[Product.PRIVATE_CAR]: {
				shortTerm: STREET_COVER_30_DAY_POLICY_BOOKLET,
				longTerm: STREET_COVER_ANNUAL_POLICY_BOOKLET,
			},
			[Product.STREET_COVER]: {
				shortTerm: STREET_COVER_30_DAY_POLICY_BOOKLET,
				longTerm: STREET_COVER_ANNUAL_POLICY_BOOKLET,
			},
		},
		[PolicyDocumentType.IPID]: {
			[Product.PRIVATE_CAR]: {
				shortTerm: STREET_COVER_30_DAY_IPID,
				longTerm: STREET_COVER_ANNUAL_IPID,
			},
			[Product.STREET_COVER]: {
				shortTerm: STREET_COVER_30_DAY_IPID,
				longTerm: STREET_COVER_ANNUAL_IPID,
			},
		},
		[addonDocumentEnums.XS_REIMBURSEMENT]: '',
		[addonDocumentEnums.XS_REIMBURSEMENT_BOOKLET]: '',
		[addonDocumentEnums.NCB_PROTECTION]: STREET_COVER_NCB_PROTECTION,
		[genericDocumentEnums.PRIVACY_POLICY]: STREET_COVER_PRIVACY_POLICY,
		[genericDocumentEnums.TERMS_OF_BUSINESS]: STREET_COVER_TERMS_OF_BUSINESS,
	},
};

function getDocument(
	product: Product,
	isShortTermPolicy: boolean,
	policyDocument: documentTypes,
	subscription?: boolean,
): string {
	const company = import.meta.env.VITE_AUTH_REALM?.toUpperCase() as Company;
	const companyDocuments = documentMappings[company] || {};
	const documentTypeMappings = companyDocuments[policyDocument] || {};

	const getDocumentUrl = (mappings: any, product: Product, isShortTerm: boolean) => {
		if (!mappings) {
			return '';
		}
		if (typeof mappings === 'string') {
			return mappings;
		}
		if (typeof mappings === 'object' && 'shortTerm' in mappings && 'longTerm' in mappings) {
			return isShortTerm ? mappings.shortTerm : mappings.longTerm;
		}
		return mappings[product] || '';
	};

	if (policyDocument === PolicyDocumentType.POLICY_WORDING || policyDocument === PolicyDocumentType.IPID) {
		const tempProduct = subscription ? Product.SUBSCRIPTION : product;
		return getDocumentUrl(documentTypeMappings[tempProduct], tempProduct, isShortTermPolicy);
	}

	return typeof documentTypeMappings === 'string' ? documentTypeMappings : '';
}

export default getDocument;
